angular.module( 'acme.view.application.finance.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.finance.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var financeList = {
        name: 'application.finance.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'FinanceListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/finance/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Finance'
        }
      };

    $stateProvider
      .state(financeList);
});
